module.exports = __webpack_public_path__ + "media/images/landing/home/categories/run-ceb42766567d309781fab9befa342f92.png";